import React from 'react';
import {Button, Radio} from 'antd';
import { t } from 'i18next';
import FormSlider from "../../elements/FormSlider";
import {GetClientType} from "../../../config";

const RadioGroupOptions = ({  profileType, selectedProduct,render,browser }) => {
    if (GetClientType() !== "3dmax"  || profileType !== "all") return null;
    
    return (
        <>
            <Radio.Group className='radio-group' onChange={(e) => {
                var newRenderOptions = render.renderOptions;
                newRenderOptions.psb = e.target.value;
                render.setRenderOptions({...newRenderOptions});
            }} value={render.renderOptions.psb}>
                <Radio value="planar">{t('product.planar')}</Radio>
                <Radio value="spherical">{t('product.spherical')}</Radio>
                <Radio value="box">{t('product.box')}</Radio>
            </Radio.Group>


            <div className='slider-back'>
                <FormSlider key={selectedProduct?.id + "uvw_scale"}
                            title={t('product.uvw_scale')} min={0} max={100}
                            defaultValue={render.renderOptions.uvw}
                            onChange={(value) => {
                                var newRenderOptions = render.renderOptions;
                                newRenderOptions.uvw = value;
                                render.setRenderOptions(newRenderOptions);
                            }}
                />
            </div>
            <div className='uvw-rotate'>
                <Button type="primary" onClick={() => browser.rotate(null)}
                        className='rotate-button'
                        icon={<span className='svg-icon icon-rotate'></span>}>
                    {t('product.rotate_45')}
                </Button>
                <Button type="primary" className='apply-button'
                        onClick={() => browser.applyUVW(selectedProduct, render.renderOptions.uvw, render.renderOptions.psb)}
                        style={{marginTop: 10, marginBottom: 20}}>
                    {t('product.apply_uvw_mapping')}
                </Button>
            </div>
        </>

    );
};

export default RadioGroupOptions;
